import React, { useState } from 'react';

interface ForceExitButtonProps {
  stepId: string;
  stepName: string;
  onForceExit: (step: string, reason: string) => void;
}

export const ForceExitButton: React.FC<ForceExitButtonProps> = ({
  onForceExit,
  stepId
}) => {
  const [reason, setReason] = useState('');

  return (
    <div className="space-y-2">
      <textarea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        className="w-full border rounded p-2 text-sm"
        placeholder="Reden beëindigen (vereist)"
        rows={2}
      />
      <button
        onClick={() => onForceExit(stepId, reason.trim() || 'Geen reden opgegeven')}
        disabled={reason.trim().length < 3}
        className={`w-full px-3 py-2 rounded ${reason.trim().length < 3 ? 'bg-red-300 text-white cursor-not-allowed' : 'bg-red-500 text-white hover:bg-red-600'}`}
      >
        Stop Gesprek
      </button>
    </div>
  );
};


